import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { useEffect, useRef } from "react";

interface ResetControlConfig {
  control: IControl;
  resetValue?: unknown;
  clearOptionItems?: boolean;
}

interface ResetArrayChildControlConfig {
  arrayControl: IControl;
  childControlName: string;
  resetValue?: unknown;
  clearOptionItems?: boolean;
}

interface UseResetCustomerDependentControlsParams {
  customerId: string | null | undefined;
  enabled?: boolean;
  controls?: ResetControlConfig[];
  arrayChildControls?: ResetArrayChildControlConfig[];
}

export const useResetCustomerDependentControls = ({
  customerId,
  enabled = true,
  controls = [],
  arrayChildControls = [],
}: UseResetCustomerDependentControlsParams) => {
  const previousCustomerIdRef = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (!enabled) {
      previousCustomerIdRef.current = undefined;
      return;
    }

    if (previousCustomerIdRef.current === undefined) {
      previousCustomerIdRef.current = customerId;
      return;
    }

    if (previousCustomerIdRef.current === customerId) return;

    previousCustomerIdRef.current = customerId;

    controls.forEach((config) => {
      if (config.clearOptionItems !== false) {
        config.control.setProp("optionItems", []);
      }

      config.control.setValueAndValidate((config.resetValue ?? "") as never);
    });

    arrayChildControls.forEach((config) => {
      config.arrayControl.children.forEach((row: IControl[]) => {
        const childControl = row.find(
          (x) => x.name === config.childControlName,
        );
        if (!childControl) return;

        if (config.clearOptionItems !== false) {
          childControl.setProp("optionItems", []);
        }

        childControl.setValueAndValidate((config.resetValue ?? "") as never);
      });
    });
  }, [arrayChildControls, controls, customerId, enabled]);
};
